//import { Component, OnInit, Renderer2, AfterViewInit, HostListener, Inject, Output, EventEmitter,Input, ChangeDetectorRef, ViewChild, ElementRef, NgZone } from '@angular/core';
//import { takeUntil } from 'rxjs/operators';

//import { ThemeSettingsService } from '../settings/theme-settings.service';
//import { Subject } from 'rxjs';
//import { AppConstants } from '../../_helpers/app.constants';
//import { DeviceDetectorService } from '../../_services/device-detector.service';
//import { DOCUMENT } from '@angular/common';

//interface ToastMessage {
//  id: number;
//  title: string;
//  message: string;
//  visible: boolean;
//}

//type RevenuePeriod = 'monthly' | 'weekly';
//type BreakdownType = 'bar' | 'pie';

///** A coloured action card on the dashboard body (Restaurant Order, etc.). */
//interface DashboardAction {
//  id: string;
//  label: string;
//  hint: string;
//  icon: string;
//  route: string;
//  accent: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//interface PlotlyLike {
//  newPlot(el: HTMLElement, data: unknown[], layout: Record<string, unknown>, config?: Record<string, unknown>): Promise<unknown>;
//  react(el: HTMLElement, data: unknown[], layout: Record<string, unknown>, config?: Record<string, unknown>): Promise<unknown>;
//  purge(el: HTMLElement): void;
//  Plots?: { resize(el: HTMLElement): void };
//}

//@Component({
//  selector: 'app-header',
//  templateUrl: './header.component.html',
//  styleUrls: ['./header.component.css']
//})
////implements OnInit, AfterViewInit
//export class HeaderComponent {
//  @Input() userName = 'Raghu';

  //layout: string;
  //private _themeSettingsConfig: any;
  //private _unsubscribeAll: Subject<any>;
  //private isMobile = false;
  //public selectedColorClass = '';

  //constructor(private _renderer: Renderer2,
  //  @Inject(DOCUMENT) private document: Document,
  //  private _themeSettingsService: ThemeSettingsService,
  //  private deviceService: DeviceDetectorService) {
  //  this._unsubscribeAll = new Subject();
  //}

  //ngOnInit() {
  //  const self = this;
  //  // Subscribe to config changes
  //  this._themeSettingsService.config
  //    .pipe(takeUntil(this._unsubscribeAll))
  //    .subscribe((config) => {
  //      this._themeSettingsConfig = config;
  //      if (config.layout && config.layout.style &&
  //        config.layout.style === 'vertical') {
  //        self.layout = 'vertical';
  //      } else {
  //        self.layout = 'horizontal';
  //      }
  //      this.refreshView();
  //    });
  //}

  //refreshView() {
  //  const self = this;

  //  const headerElement = document.getElementsByClassName('header-navbar');
  //  if (headerElement.item(0)) {
  //    let currentHeaderClassList = [];
  //    const navbar = this.document.getElementById('navbar-mobile');
  //    // Layout
  //    if (self._themeSettingsConfig.layout.style === 'horizontal') {
  //      currentHeaderClassList = ['header-navbar', 'navbar-expand-md', 'navbar', 'navbar-with-menu',
  //        'navbar-without-dd-arrow', 'navbar-static-top'];
  //      const topHeaderElement = document.getElementById('top-header');
  //      if (window.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH_HORIZONTAL) {
  //        currentHeaderClassList.push('fixed-top');
  //        this._renderer.removeClass(topHeaderElement, 'navbar-brand-center');
  //        navbar.classList.remove('show');
  //      } else {
  //        currentHeaderClassList.push('navbar-brand-center');
  //        this._renderer.removeClass(topHeaderElement, 'fixed-top');
  //        navbar.classList.add('show');
  //      }
  //    } else {
  //      currentHeaderClassList = ['header-navbar', 'navbar-expand-md', 'navbar', 'navbar-with-menu', 'navbar-without-dd-arrow', 'fixed-top',
  //        'navbar-shadow'];

  //      if (self._themeSettingsConfig.colorTheme === 'semi-light' && self._themeSettingsConfig.layout.style === 'vertical') {
  //        if (self._themeSettingsConfig.layout.style === 'vertical') {
  //          // currentHeaderClassList.push('bg-info');
  //        }
  //        self._renderer.addClass(headerElement.item(0), 'navbar-semi-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-dark');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-semi-dark');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-light');
  //      } else if (self._themeSettingsConfig.colorTheme === 'semi-dark' && self._themeSettingsConfig.layout.style === 'vertical') {
  //        self._renderer.addClass(headerElement.item(0), 'navbar-semi-dark');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-semi-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-dark');
  //        // self._renderer.removeClass(headerElement.item(0), 'bg-info');
  //      } else if (self._themeSettingsConfig.colorTheme === 'dark' && self._themeSettingsConfig.layout.style === 'vertical') {
  //        self._renderer.addClass(headerElement.item(0), 'navbar-dark');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-semi-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-semi-dark');
  //        // self._renderer.removeClass(headerElement.item(0), 'bg-info');
  //      } else if (self._themeSettingsConfig.colorTheme === 'light' && self._themeSettingsConfig.layout.style === 'vertical') {
  //        self._renderer.addClass(headerElement.item(0), 'navbar-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-semi-light');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-semi-dark');
  //        self._renderer.removeClass(headerElement.item(0), 'navbar-dark');
  //        // self._renderer.removeClass(headerElement.item(0), 'bg-info');
  //      }
  //    }



  //    currentHeaderClassList.forEach(function (c) {
  //      self._renderer.addClass(headerElement.item(0), c);
  //    });


  //  }
  //}

  //ngAfterViewInit() {
  //  this.refreshView();
  //}

  //@HostListener('window:resize', ['$event'])
  //onResize(event) {
  //  if (event.target.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH) {
  //    this.isMobile = true;
  //  } else {
  //    this.isMobile = false;
  //  }
  //  this.refreshView();
  //}
  //@HostListener('document:mousemove', ['$event'])
  //onMouseMove(e) {
  //  if (document.getElementsByClassName('modal-backdrop').length>0) {
  //    document.getElementsByClassName('modal-backdrop')[0].removeAttribute("style")
  //  }
  //}
  //@Output() toggleSidebar = new EventEmitter<void>();
//  @Output() themeChanged = new EventEmitter<boolean>();
//  private chartErrorShown = false;
//  constructor(
//    @Inject(DOCUMENT) private readonly documentRef: Document,
//    private readonly changeDetectorRef: ChangeDetectorRef, private readonly ngZone: NgZone,) { }


//  isDarkMode = false;
//  sidebarOpen = false;
//  private toastId = 0;
//  private toastTimers: number[] = [];
//  toasts: ToastMessage[] = [];


//  toggleSidebar(): void { this.sidebarOpen = !this.sidebarOpen; }
//  closeSidebar(): void { this.sidebarOpen = false; }
//  get userInitial(): string {
//    return (this.userName || '?').trim().charAt(0).toUpperCase();
//  }
//  //onToggleTheme() {
//  //  this.isDark = !this.isDark;
//  //  document.documentElement.dataset['theme'] = this.isDark ? 'dark' : 'light';
//  //  this.themeChanged.emit(this.isDark);
//  //}

//  toggleTheme(): void {
//    this.isDarkMode = !this.isDarkMode;
//    //this.changeDetectorRef.markForCheck();
//    //this.ngZone.runOutsideAngular(() => {
//    //  window.setTimeout(() => this.renderAllCharts(), 100);
//    //});
//    document.documentElement.dataset['theme'] = this.isDarkMode ? 'dark' : 'light';
//    this.themeChanged.emit(this.isDarkMode);
//    //document.body.classList.toggle('dark-theme', this.isDarkMode);
//  }
//  onNotification() {
//    // Handle notification click
//  }

//  private removeToast(id: number): void {
//    this.toasts = this.toasts.filter((t) => t.id !== id);
//    this.changeDetectorRef.markForCheck();
//  }
//  private setToastVisibility(id: number, visible: boolean): void {
//    this.toasts = this.toasts.map((t) => (t.id === id ? { ...t, visible } : t));
//    this.changeDetectorRef.markForCheck();
//  }
//  showToast(title: string, message: string): void {
//    const toast: ToastMessage = { id: ++this.toastId, title, message, visible: false };
//    this.toasts = [...this.toasts, toast];
//    this.changeDetectorRef.markForCheck();
//    const showTimer = window.setTimeout(() => this.setToastVisibility(toast.id, true), 20);
//    const hideTimer = window.setTimeout(() => this.setToastVisibility(toast.id, false), 3000);
//    const removeTimer = window.setTimeout(() => this.removeToast(toast.id), 3350);
//    this.toastTimers.push(showTimer, hideTimer, removeTimer);
//  }
//  onCart() {
//    // Handle cart click
//  }

//}




// import {
//   ChangeDetectionStrategy,
//   ChangeDetectorRef,
//   Component,
//   EventEmitter,
//   HostBinding,
//   Input,
//   OnInit,
//   Output,
// } from '@angular/core';
// import { Router } from '@angular/router';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { Account } from '../../model/account.model';
// import { ClientRegistration } from '../../model/client.model';
// import { Guid } from '../../_helpers/guid';
// import { ChromeService } from '../../_services/chrome.service'
// import { NotificationService } from '../../_services/domainservice/notification.service';
// import { Product } from '../../model/product.model';
// import { AlertService } from '../../_services/alert.service';
// import { Notification } from '../../model/notification.model';
// import { SharedComponent } from '../../../shared/shared.component';
// import { HttpErrorResponse } from '@angular/common/http';
// /**
//  * Drop-in dashboard header. Designed to sit next to <app-verticalnav>:
//  * the header is fixed at top with `left: 260px` (the sidebar width),
//  * so it never overlaps the sidebar.
//  *
//  * Toggles dark mode by setting `data-theme="dark"` on <html>. Any
//  * component that wants to react to the theme should use
//  *   :host-context([data-theme="dark"]) { ... }
//  * in its own CSS (the verticalnav already does this).
//  *
//  * USAGE in your parent layout:
//  *   <app-billing-header
//  *     [pageTitle]="'Billing Dashboard'"
//  *     [userName]="'Raghu'"
//  *     (sidebarToggle)="onSidebarToggle()">
//  *   </app-billing-header>
//  */
// @Component({
//   selector: 'app-header',
//     templateUrl: './header.component.html',
//     styleUrls: ['./header.component.css'],
//   changeDetection: ChangeDetectionStrategy.OnPush,
// })
// export class HeaderComponent extends SharedComponent implements OnInit {

//   //@Input() pageTitle = 'Billing Dashboard';
//   @Input() userName = JSON.parse(localStorage.getItem('currentUser')).name;

//   @Input() searchPlaceholder = 'Search transactions, orders…';
//   //@Input() notificationCount = 3;
//   @Input() cartCount = 2;
//   /** When `full`, the header spans the entire viewport. When `shifted` (default), it leaves 260px on the left for the sidebar. */
//   @Input() sidebarBasis: 'shifted' | 'full' = 'shifted';

//   @Output() sidebarToggle = new EventEmitter<void>();
//   @Output() themeChanged = new EventEmitter<boolean>();

//   @HostBinding('class.full')
//   get isFull(): boolean { return this.sidebarBasis === 'full'; }

//   isDarkMode = false;
//   public selectedProductUId: Guid;
//   public selectedClientUId: Guid;
//   public selectedRoleBasedlogedin: Guid;
//   public selectedLoggedinUId: Guid;
//   public selectedemailid: string;
//   public ProductDetailsList: Array<Product>;
//   public Clientregistrationlist: Array<ClientRegistration>;
//   public Clients: Array<ClientRegistration>;
//   client: ClientRegistration = new ClientRegistration;
//   public Accountlist: Array<Account>;
//   public Notificationlist: Array<Notification>

//   notifications: string;
//   notification: Notification = new Notification;
//   notificationuid: Guid;
//   registrationUId: Guid;
//   //showNotifications = true;
//   public count: number = 0;
//   name: string;
//   styles = {
//     bellButton: {
//       root: {
//         svg: {
//           color: 'white',
//           width: '25px',
//           height: '20px',
//           fill: 'white',
//         },
//       },
//       dot: {
//         rect: {
//           fill: 'rgb(221, 0, 49)',
//           strokeWidth: '0.2',
//           stroke: 'white',
//           width: '3.5px',
//           height: '3.5px',
//         },
//         left: '40%',
//       },
//     },
//     header: {
//       root: {
//         backgroundColor: '',
//         '&:hover': { backgroundColor: '' },
//         '.some_class': { color: '' },
//       },
//     },
//     layout: {
//       root: {
//         backgroundColor: '',
//       },
//     },
//     popover: {
//       arrow: {
//         backgroundColor: '',
//         border: '',
//       },
//     },
//   };
//   constructor(private readonly cd: ChangeDetectorRef,
//     private readonly chrome: ChromeService,
//     private router: Router,
//     private notificationService: NotificationService,
//     private spinner: NgxSpinnerService,
//     private alertService: AlertService,

//   ) { super() }

//   ngOnInit(): void {
//     if (typeof window === 'undefined') return;
//     const saved = localStorage.getItem('billing-theme');
//     this.isDarkMode = saved === 'dark';
//     this.applyTheme();
//     //console.log(this.userName);
//   }

//   toggleNotifications() {
//     //this.showNotifications = !this.showNotifications;
//     this.selectedClientUId = localStorage.getItem('CurrentClientUId');
//     this.selectedRoleBasedlogedin = localStorage.getItem('CurrentRoleBasedlogedin');
//     this.notificationService.getNotification(this.selectedClientUId.toString(), this.selectedRoleBasedlogedin.toString()).subscribe((notificationdetails): void => {
//       this.Notificationlist = notificationdetails;
//       this.count = notificationdetails.length;
//       if (this.count == 0) {
//         this.alertService.info("Notification Not Found");
//         //this.showNotifications = !this.showNotifications;
//       }
//       else {
//         for (var i = 0; i < notificationdetails.length; i++) {
//           this.notificationuid = notificationdetails[i].notificationUId;
//           this.notifications = this.Notificationlist[i].message;
//           this.registrationUId = this.Notificationlist[i].gymRegistrationUId;
//           this.notification.modifiedByApp = this.Notificationlist[i].modifiedByApp;
//           this.notification.modifiedByUser = this.Notificationlist[i].modifiedByUser;
//           this.name = this.Notificationlist[i].name;
//           this.UpdateViewedNotification();
//         }
//       }
//     })
//   }
//   UpdateViewedNotification() {
//     this.notification.itemState = 2;
//     this.notification.notificationUId = this.notificationuid;
//     this.notification.message = this.notifications;
//     this.notification.isViewed = true;
//     this.notification.productUId = this.selectedProductUId;
//     this.notification.gymRegistrationUId = this.registrationUId;
//     this.notification.clientRegistrationUId = this.selectedClientUId;
//     this.notification.roleBasedLogedin = this.selectedRoleBasedlogedin;
//     this.notification.name = this.name;
//     this.notification.createdByUser = this.notification.modifiedByUser;
//     this.notification.createdByApp = this.notification.modifiedByApp;
//     this.setAuditFields(this.notification);
//     this.notificationService.mergeNotification(this.notification, 'Edit').subscribe((): void => {
//     },
//       (error: HttpErrorResponse): void => {
//         console.log(error);
//         this.alertService.error(error.message);
//         this.spinner.hide();
//       });
//   }

//   toggleTheme(): void {
//     this.isDarkMode = !this.isDarkMode;
//     if (typeof window !== 'undefined') {
//       localStorage.setItem('billing-theme', this.isDarkMode ? 'dark' : 'light');
//     }
//     this.applyTheme();
//     this.themeChanged.emit(this.isDarkMode);
//     this.cd.markForCheck();
//   }

//   private applyTheme(): void {
//     if (typeof document === 'undefined') return;
//     document.documentElement.setAttribute('data-theme', this.isDarkMode ? 'dark' : 'light');
//   }
//   ResetPasswordPage() {
//     this.router.navigate(['/authentication/resetpassword']);
//   }

//   onSidebarToggle(): void { this.sidebarToggle.emit(); }
//   onBellClick(): void {
//     //this.showNotifications = !this.showNotifications;
//     this.selectedClientUId = localStorage.getItem('CurrentClientUId');
//     this.selectedRoleBasedlogedin = localStorage.getItem('CurrentRoleBasedlogedin');
//     this.notificationService.getNotification(this.selectedClientUId.toString(), this.selectedRoleBasedlogedin.toString()).subscribe((notificationdetails): void => {
//       this.Notificationlist = notificationdetails;
//       this.count = notificationdetails.length;
//       if (this.count == 0) {
//         this.alertService.info("Notification Not Found");
//         //this.showNotifications = !this.showNotifications;
//       }
//       else {
//         for (var i = 0; i < notificationdetails.length; i++) {
//           this.notificationuid = notificationdetails[i].notificationUId;
//           this.notifications = this.Notificationlist[i].message;
//           this.registrationUId = this.Notificationlist[i].gymRegistrationUId;
//           this.notification.modifiedByApp = this.Notificationlist[i].modifiedByApp;
//           this.notification.modifiedByUser = this.Notificationlist[i].modifiedByUser;
//           this.name = this.Notificationlist[i].name;
//           this.UpdateViewedNotification();
//         }
//       }
//     }) }
//   onCartClick(): void { /* hook in your cart service here */ }
//   onUserClick(): void { /* hook in your account menu here */ }

//   toggleSidebar(): void {
//     this.chrome.toggleSidebar();
//   }


//   get userInitial(): string {
//     return (this.userName || '?').trim().charAt(0).toUpperCase();
//   }
// }



import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
// Import depth normalized to 1 level up (NewLogin_RelatedFile/_services, /model, /shared) so this
// package compiles standalone — see NewLogin_RelatedFile/angular-workspace-notes.ts. Originally
// written 2 (and 3, for shared.component) levels up on the unevidenced guess that Header/ lives
// nested inside your real app; if it does, restore the original depth instead.
import { AlertService } from '../../_services/alert.service';
import { ChromeService } from '../../_services/chrome.service'
import { CoreGymService } from '../../_services/core.gym.service.service';
import { NotificationService } from '../../_services/domainservice/notification.service';
import { Notification } from '../../model/notification.model';
// Capitalized 'Shared/' (not 'shared/') to match the actual on-disk folder name — this project's
// Shared/ directory already exists (holding the C# backend files) and shared.component.ts was
// added into that same folder rather than creating a second, case-different one. Windows resolves
// either casing, but a case-sensitive build (Linux CI, Docker) would fail on 'shared/' — see
// angular-workspace-notes.ts.
import { SharedComponent } from '../../../shared/shared.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class HeaderComponent extends SharedComponent implements OnInit {

  userName = '';
  @Input() searchPlaceholder = 'Explore...';

  currentUser: any;
  companyName = '';
  logo = '';
  companyLogoUrl = '';
  Notificationlist: Array<Notification>;
  notifications: string;
  notification: Notification = new Notification;
  notificationuid: any;
  registrationUId: any;
  selectedClientUId: any;
  selectedRoleBasedlogedin: any;
  selectedProductUId: any;
  name: string;
  count = 0;

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly chrome: ChromeService,
    private readonly router: Router,
    private readonly coreGymService: CoreGymService,
    private readonly notificationService: NotificationService,
    private readonly spinner: NgxSpinnerService,
    private readonly alertService: AlertService,
  ) { super(); }

  // ngOnInit(): void {
  //   this.currentUser = this.safeJsonParse(localStorage.getItem('currentUser')) || {};
  //   console.log(this.currentUser);
  //   this.userName = this.currentUser?.name;
  //   //this.userName || this.currentUser?.name || 'User';

  //   this.companyName = this.currentUser?.companyName || localStorage.getItem('CompanyName') || 'KG Technologys';
  //   this.logo = this.currentUser?.logo || localStorage.getItem('CompanyLogo') || '';
  //   this.companyLogoUrl = this.logo
  //     ? this.coreGymService.BaseUrl + this.logo
  //     : 'assets/custom/images/abg/abglogoicon512.ico';
  // }
  ngOnInit(): void {
    this.currentUser = this.safeJsonParse(localStorage.getItem('currentUser')) || {};

    console.log('Current User:', this.currentUser);

    this.userName =
      this.currentUser?.name ||
      this.currentUser?.userName ||
      this.currentUser?.username ||
     
      localStorage.getItem('UserName') ||
      'User';

    console.log('Header User Name:', this.userName);

    this.companyName =
      this.currentUser?.companyName ||
      localStorage.getItem('CompanyName') ||
      'KG Technologys';

    this.logo =
      this.currentUser?.logo ||
      localStorage.getItem('CompanyLogo') ||
      '';

    this.companyLogoUrl = this.logo
      ? this.coreGymService.BaseUrl + this.logo
      : 'assets/custom/images/abg/abglogoicon512.ico';

    this.cd.markForCheck();
  }

  toggleSidebar(): void {
    this.chrome.toggleSidebar();
  }

  onBellClick(): void {
    this.selectedClientUId = localStorage.getItem('CurrentClientUId');
    this.selectedRoleBasedlogedin = localStorage.getItem('CurrentRoleBasedlogedin');
    this.notificationService.getNotification(this.selectedClientUId?.toString(), this.selectedRoleBasedlogedin?.toString()).subscribe((notificationdetails): void => {
      this.Notificationlist = notificationdetails;
      this.count = notificationdetails.length;
      if (this.count === 0) {
        this.alertService.info('Notification Not Found');
      } else {
        for (let i = 0; i < notificationdetails.length; i++) {
          this.notificationuid = notificationdetails[i].notificationUId;
          this.notifications = this.Notificationlist[i].message;
          this.registrationUId = this.Notificationlist[i].gymRegistrationUId;
          this.notification.modifiedByApp = this.Notificationlist[i].modifiedByApp;
          this.notification.modifiedByUser = this.Notificationlist[i].modifiedByUser;
          this.name = this.Notificationlist[i].name;
          this.UpdateViewedNotification();
        }
      }
    });
  }

  UpdateViewedNotification(): void {
    this.notification.itemState = 2;
    this.notification.notificationUId = this.notificationuid;
    this.notification.message = this.notifications;
    this.notification.isViewed = true;
    this.notification.productUId = this.selectedProductUId;
    this.notification.gymRegistrationUId = this.registrationUId;
    this.notification.clientRegistrationUId = this.selectedClientUId;
    this.notification.roleBasedLogedin = this.selectedRoleBasedlogedin;
    this.notification.name = this.name;
    this.notification.createdByUser = this.notification.modifiedByUser;
    this.notification.createdByApp = this.notification.modifiedByApp;
    this.setAuditFields(this.notification);
    this.notificationService.mergeNotification(this.notification, 'Edit').subscribe(
      (): void => { },
      (error: HttpErrorResponse): void => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      }
    );
  }

  ResetPasswordPage(): void {
    this.router.navigate(['/authentication/resetpassword']);
  }

  get userInitial(): string {
    return (this.userName || '?').trim().charAt(0).toUpperCase();
  }

  private safeJsonParse(value: string | null): any {
    if (!value) return null;
    try { return JSON.parse(value); } catch { return null; }
  }
}

